





















import Component from 'vue-class-component'
import Vue from 'vue'
import { Injector } from '@/config/dependency-injection'
import { StorageService } from '@/shared/utils/storage-service'
import { bootstrap } from 'vue-gtag'
import { environmentConfiguration } from '@/config/environments'

@Component({
  name: 'cookie-consent',
})
export default class CookieConsent extends Vue {
  public show = false

  private storageService = Injector.get(StorageService)

  public mounted() {
    if (environmentConfiguration().cookieConsent === true) {
      const cookiesAllowed = this.storageService.getItem('cookie.allow')

      if (cookiesAllowed === true) {
        this.show = false
        bootstrap()
      } else if (cookiesAllowed === undefined) {
        this.show = true
      }
    }
  }

  public allow(): void {
    this.storageService.setItem('cookie.allow', true)
    bootstrap()

    this.hide()
  }

  public deny(): void {
    this.storageService.setItem('cookie.allow', false)

    this.hide()
  }

  private hide(): void {
    this.show = false
  }
}
